import {createRestfulApi} from "./createRestfulApi";
import request from "@/helpers/request";

const URL = {
    // 订单列表
    GETORDERRESPONSELIST: "order/getOrderResponseList",
    SET_ORDER_FREE: "order/setOrderFree",
};

export default {
    getOrderResponseList: createRestfulApi(URL.GETORDERRESPONSELIST, {
        queryParams: [],
    }),
  setOrderFree({id}) {
        return request(URL.SET_ORDER_FREE, "POST", {id});
    },
};
